import { render } from "./TournamentCreatePage.vue?vue&type=template&id=e9b67940"
import script from "./TournamentCreatePage.vue?vue&type=script&lang=js"
export * from "./TournamentCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__